import React, { useEffect } from 'react';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';

interface BottomSheetProps {
  children?: React.ReactNode;
  width?: string;
  minHeight?: string;
  maxHeight?: string;
  visible?: boolean;
  documentClass?: string;
}

const BottomSheetComponent = (props: BottomSheetProps) => {
  const {
    children,
    width = '100%',
    minHeight = '92%',
    maxHeight = '92%',
    visible = false,
    documentClass = 'bottom-sheet-default',
  } = props;

  useEffect(() => {
    const html = document.getElementsByTagName('html')[0];
    html.classList[visible ? 'add' : 'remove'](
      'bottom-sheet-document',
      documentClass
    );
  }, [visible]);

  return visible ? (
    <div className="bottom-sheet-overlay">
      <div className="bottom-sheet" style={{ width, minHeight, maxHeight }}>
        {children}
      </div>
    </div>
  ) : null;
};

interface SwipeAbleBottomSheetProps {
  children: React.ReactNode;
  isOpen?: boolean;
  onClose: () => void;
  onOpen?: () => void;
  className?: string;
  disableCloseOnBackdropClick?: boolean;
}

const SwipeAbleBottomSheet = (props: SwipeAbleBottomSheetProps) => {
  const {
    children,
    isOpen = false,
    onClose,
    onOpen = () => null,
    className,
    disableCloseOnBackdropClick = true,
  } = props;
  return (
    <SwipeableDrawer
      anchor="bottom"
      open={isOpen}
      onClose={onClose}
      onOpen={onOpen}
      className={className}
      disableSwipeToOpen
      ModalProps={{
        disableBackdropClick: disableCloseOnBackdropClick,
      }}
    >
      {children}
    </SwipeableDrawer>
  );
};

export { SwipeAbleBottomSheet };
export default BottomSheetComponent;
